import React from "react";
import { formatChatTimestamp } from "../utils/vertex360CopilotChatUtils";

const ChatTimestamp = ({ iso, className = "" }) => {
  const label = formatChatTimestamp(iso);
  if (!label) return null;

  return (
    <div
      className={`flex justify-center py-2 ${className}`}
      aria-label={`Message sent ${label}`}
    >
      <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-[10px] font-medium text-slate-500">
        {label}
      </span>
    </div>
  );
};

export default ChatTimestamp;
